import { useRecoilValue } from 'recoil';
import { roles } from './atoms';

export const useRoles = () => useRecoilValue(roles);

